import { Box, Container, Paper, Typography } from "@material-ui/core";
import React from "react";
import { useAuth } from "../../context/AuthContext";
import { Column, Row } from "../utils/MaterialUIComponents";

const Stats = () => {
  const { activeUser } = useAuth();
  return (
    <Container>
      <Typography variant="h2">My Stats</Typography>
      <Paper component={Box} p={3}>
        <Row>
          <Column lg={6}>Username:</Column>
          <Column lg={6}>{activeUser.username}</Column>
        </Row>
        <Row>
          <Column lg={6}>Email:</Column>
          <Column lg={6}>{activeUser.email}</Column>
        </Row>
        <Row>
          <Column lg={6}>Points</Column>
          <Column lg={6}>{activeUser.points}</Column>
        </Row>
      </Paper>
    </Container>
  );
};

export default Stats;
